/**
 * Component: External links modal
 * ------------------------------------------------------------------------------
 * Before opening an external link a warning modal will be shown
 *
 * @namespace ewExternalLinkPopup
 */
import log from 'salvo-lite/log'

import {linkExternal} from '../helpers/utils'

class ServicePlansForm {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._settings = {
            modalEnabler: '[js-ew-modal="enabled"]',
            modalLink: '[js-ew-popup="agree"]',
            modalParagraph: '[js-ew-popup="paragraph"]',
            ...JSON.parse(elem.getAttribute('data-external-link-popup') || '{}')
        }

        this._namespace = 'quick-view'
        this._modalLinkAttribute = 'js-ew-popup'

        /**
         * DOM node selectors.
         */
        this._nodeSelectors = {
            modalEnabler: document.querySelector(this._settings.modalEnabler),
            modalLink: document.querySelector(this._settings.modalLink),
            modalParagraph: document.querySelector(this._settings.modalParagraph)
        }

        /**
         * Global instances.
         */

        log.debug(this.constructor.name, 'Constructed', this)
    }

    /**
     * Initialise component.
     */
    onInit () {
        if (!this._nodeSelectors.modalEnabler) {
            return
        }

        this._modalEventListeners()
        this._modal = this._theme.getComponentsById('external-popup')._modal
    }

    /**
     * Set conditions on when to show the modal.
     */
    _modalEventListeners () {
        document.addEventListener('click', (event) => {
            const targetElement = event.target.tagName.toLowerCase()
            const targetAttribute = event.target.hasAttribute(this._modalLinkAttribute)

            if (targetElement === 'a' && targetAttribute === false && linkExternal(event.target)) {
                event.preventDefault()
                this._nodeSelectors.modalParagraph.innerHTML = this._nodeSelectors.modalParagraph.innerHTML.replace(/%forward%/g, event.target.host)
                this._nodeSelectors.modalLink.setAttribute('href', event.target.href)
                this._modal.show('quick-view')
            }
        })

        this._nodeSelectors.modalLink.addEventListener('click', () => {
            this._modal.close('quick-view')
        })
    }

    /**
     * Expose public interface.
     */
    // return Object.freeze({
    //     init,
    // });
}

export default ServicePlansForm



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ExternalLinkPopup.js